(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playr-advertorial-v2"] && !Shopify.designMode) return;
  try {
    
/**
 * PLAYR Advertorial cart bridge.
 *
 * Loaded as a THEME ASSET via theme.liquid ({{ 'playr-advertorial-bridge.js' | asset_url | script_tag }}).
 * Asset files are served with versioned URLs and are NOT subject to the Liquid
 * page/section/snippet render cache, so updates here go live immediately on push.
 * (Raw <script>/custom-element markup inside the page section gets stripped by
 * Shopify's content filter — an asset script does not, which is why this lives here.)
 *
 * Two features:
 *   (1) FREE-SHAKER AUTO-ADD — when a subscription item is in the cart and the
 *       free shaker is not, add one shaker so it shows as FREE in the drawer.
 *   (2) ADVERTORIAL CART-DRAWER WIRING — intercept the tier <form data-playr-form>
 *       submits, AJAX-add to cart via /cart/add.js (requesting the cart-drawer
 *       sections so the Horizon drawer can refresh), dispatch the theme's
 *       cart:update event, then open the slide-out drawer.
 *
 * Both are gated so the shaker logic runs everywhere but the form wiring only
 * activates when the advertorial root ([data-playr-root]) is present.
 */
(function () {
  'use strict';

  /* ===================================================================
   * (1) FREE-SHAKER AUTO-ADD
   * =================================================================== */
  var SHAKER_VARIANT_ID = 47304416526571;
  var SHAKER_HANDLE = 'free-shaker-with-first-order';
  var ATTEMPT_KEY = 'playr:shakerAutoAddAttempts';
  var MAX_ATTEMPTS_PER_SESSION = 3;
  var adding = false;

  function getAttempts() {
    try { return parseInt(sessionStorage.getItem(ATTEMPT_KEY) || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpAttempts() {
    try { sessionStorage.setItem(ATTEMPT_KEY, String(getAttempts() + 1)); }
    catch (e) {}
  }
  function resetAttempts() {
    try { sessionStorage.setItem(ATTEMPT_KEY, '0'); } catch (e) {}
  }

  // Returns a promise that resolves true if a shaker was added (so caller can refresh the drawer).
  function addShakerIfNeeded() {
    if (adding) return Promise.resolve(false);
    if (getAttempts() >= MAX_ATTEMPTS_PER_SESSION) return Promise.resolve(false);
    adding = true;
    return fetch('/cart.js')
      .then(function (r) { if (!r.ok) throw new Error('cart.js failed'); return r.json(); })
      .then(function (cart) {
        var hasSub = false, hasShaker = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].selling_plan_allocation) hasSub = true;
          if (cart.items[i].handle === SHAKER_HANDLE) hasShaker = true;
        }
        if (hasSub && !hasShaker) {
          bumpAttempts();
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: SHAKER_VARIANT_ID, quantity: 1 }] })
          }).then(function (r) { return r.ok; });
        }
        return false;
      })
      .catch(function () { return false; })
      .finally(function () { adding = false; });
  }

  /* ===================================================================
   * (2) ADVERTORIAL CART-DRAWER WIRING
   * =================================================================== */

  // --- runtime style: neutralize the display:none ancestor that hides the
  // nested <cart-drawer-component>, and force a fixed slide-out dialog. ---
  var STYLE_ID = 'playr-ppp-drawer-fix';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '#header-group{display:block !important;height:0 !important;min-height:0 !important;overflow:visible !important;visibility:visible !important;}'
      + '#header-group > .shopify-section:not(.cart-drawer-section),#header-group .header-section,#header-group .announcement-bar{display:none !important;}'
      + 'cart-drawer-component,.cart-drawer{display:block !important;visibility:visible !important;height:auto !important;overflow:visible !important;}'
      + 'cart-drawer-component > [data-testid="cart-drawer-trigger"],.cart-drawer > .header-actions__action{display:none !important;}'
      + 'dialog.cart-drawer__dialog,.cart-drawer__dialog{position:fixed !important;inset:0 0 0 auto !important;z-index:2147483000 !important;width:min(420px,92vw) !important;max-width:92vw !important;height:100dvh !important;max-height:100dvh !important;margin:0 !important;}'
      + 'dialog.cart-drawer__dialog:not([open]),.cart-drawer__dialog:not([open]){display:none !important;}'
      + 'dialog.cart-drawer__dialog[open],.cart-drawer__dialog[open]{display:flex !important;flex-direction:column !important;visibility:visible !important;}'
      + 'dialog.cart-drawer__dialog[open]::backdrop,.cart-drawer__dialog[open]::backdrop{background:rgba(15,23,42,0.5) !important;}';
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function getComp() { return document.querySelector('cart-drawer-component'); }
  function getDialog() {
    return document.querySelector('dialog.cart-drawer__dialog, .cart-drawer__dialog, cart-drawer-component dialog');
  }

  // Ask the theme's cart drawer to refresh its line items from the server, then
  // dispatch the cart:update event so cart-items-component morphs in the new HTML.
  function refreshDrawerSections() {
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });
    var url = '/?sections=' + encodeURIComponent(sectionIds.join(',')) + '&sections_url=' + encodeURIComponent(window.location.pathname);
    if (!sectionIds.length) {
      // Fallback: just fire a bare cart:update so listeners re-fetch.
      try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })); } catch (e) {}
      return Promise.resolve();
    }
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'playr-advertorial-bridge', data: { sections: sections } }
          }));
        } catch (e) {}
      })
      .catch(function () {
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })); } catch (e) {}
      });
  }

  function openDrawer() {
    injectStyle();
    var comp = getComp();
    if (comp && typeof comp.open === 'function') {
      try { comp.open(); var d0 = getDialog(); if (d0 && d0.open) return true; } catch (e) {}
    }
    var trig = document.querySelector('[data-testid="cart-drawer-trigger"], cart-drawer-component summary, [aria-controls*="cart-drawer"]');
    if (trig) {
      try { trig.click(); var d1 = getDialog(); if (d1 && d1.open) return true; } catch (e) {}
    }
    var dlg = getDialog();
    if (dlg) {
      try {
        if (dlg.open) { try { dlg.close(); } catch (e2) {} }
        if (typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
        dlg.setAttribute('open', '');
        if (typeof dlg.show === 'function') dlg.show();
        return true;
      } catch (e) {}
    }
    return false;
  }
  window.PLAYR_openCartDrawer = openDrawer;

  function setBtn(form, state, msg) {
    var btn = form.querySelector('[data-playr-cta]') || form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-cta-label]');
    if (!label) return;
    if (state === 'loading') {
      if (!label.hasAttribute('data-orig')) label.setAttribute('data-orig', label.textContent);
      label.textContent = 'Adding\u2026';
      if (btn) btn.classList.add('is-loading');
    } else if (state === 'added') {
      label.textContent = '\u2713 Added';
      if (btn) btn.classList.remove('is-loading');
    } else if (state === 'error') {
      label.textContent = msg || 'Sold out';
      if (btn) btn.classList.remove('is-loading');
    } else {
      if (label.hasAttribute('data-orig')) label.textContent = label.getAttribute('data-orig');
      if (btn) btn.classList.remove('is-loading');
    }
  }

  function rawAdd(variantId, sellingPlanId, quantity) {
    var item = { id: variantId, quantity: quantity || 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    });
  }

  function bindForms() {
    var forms = document.querySelectorAll('[data-playr-form]');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.dataset.pppBound === '1') return;
        form.dataset.pppBound = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (form.dataset.pppBusy === '1') return;
          form.dataset.pppBusy = '1';
          setBtn(form, 'loading');

          var idEl = form.querySelector('[name="id"]');
          var spEl = form.querySelector('[name="selling_plan"]');
          var qtyEl = form.querySelector('[name="quantity"]');
          var variantId = idEl ? idEl.value : null;
          var sellingPlanId = (spEl && spEl.value) ? spEl.value : null;
          var quantity = (qtyEl && parseInt(qtyEl.value, 10)) ? parseInt(qtyEl.value, 10) : 1;

          if (!variantId) {
            setBtn(form, 'error', 'Unavailable');
            form.dataset.pppBusy = '';
            setTimeout(function () { setBtn(form, 'reset'); }, 2400);
            return;
          }

          // Each new add session should be allowed to (re)add the shaker.
          resetAttempts();

          rawAdd(variantId, sellingPlanId, quantity).then(function (r) {
            if (r && r.ok === false) {
              var m = (r.data && (r.data.description || r.data.message)) || 'Sold out';
              setBtn(form, 'error', m);
              form.dataset.pppBusy = '';
              setTimeout(function () { setBtn(form, 'reset'); }, 2600);
              return;
            }
            setBtn(form, 'added');

            // For subscription items, auto-add the free shaker, THEN refresh + open.
            var post = sellingPlanId ? addShakerIfNeeded() : Promise.resolve(false);
            post.then(function () {
              return refreshDrawerSections();
            }).then(function () {
              var opened = openDrawer();
              if (!opened) { window.location.href = '/cart'; return; }
              form.dataset.pppBusy = '';
              setTimeout(function () { setBtn(form, 'reset'); }, 1600);
            });
          }).catch(function () {
            // Hard fallback: let the native form post so the user still reaches cart.
            form.dataset.pppBusy = '';
            try { form.submit(); } catch (e) { window.location.href = '/cart'; }
          });
        });
      })(forms[i]);
    }
  }

  /* ===================================================================
   * BOOT
   * =================================================================== */
  function boot() {
    // Shaker auto-add runs everywhere (handles direct cart visits too).
    addShakerIfNeeded();

    // Re-run shaker check whenever a <dialog> opens (cart drawer).
    try {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.target && m.target.tagName === 'DIALOG' && m.target.hasAttribute('open')) {
            setTimeout(addShakerIfNeeded, 400);
            break;
          }
        }
      });
      observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
    } catch (e) {}

    // Advertorial-only: wire the tier forms + drawer.
    if (document.querySelector('[data-playr-root]')) {
      injectStyle();
      bindForms();
      try {
        var mo = new MutationObserver(bindForms);
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ===== Free-gift enforcer (self-contained, merged from free-gift-enforcer.js) ===== */

  function fgGetCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function fgChangeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function fgIsGiftItem(item) {
    return item.properties && item.properties._free_gift === 'true';
  }

  function fgEnforce() {
    return fgGetCart().then(function (cart) {
      if (!cart || !cart.items) return;

      var giftLines = [];
      var hasNonGift = false;

      cart.items.forEach(function (item, idx) {
        var line = idx + 1;
        if (fgIsGiftItem(item)) {
          giftLines.push({ line: line, qty: item.quantity });
        } else {
          hasNonGift = true;
        }
      });

      // Remove gift if it's the only item
      if (!hasNonGift && giftLines.length) {
        return Promise.all(giftLines.map(function (g) { return fgChangeLine(g.line, 0); }));
      }

      // Force gift qty back to 1
      var overQty = giftLines.filter(function (g) { return g.qty > 1; });
      if (overQty.length) {
        return Promise.all(overQty.map(function (g) { return fgChangeLine(g.line, 1); }));
      }
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fgEnforce(); });
  } else {
    fgEnforce();
  }

  // Re-run when cart drawer opens / updates
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('[href*="/cart"]') ||
      e.target.closest('button[name="checkout"]') ||
      e.target.closest('.cart-drawer') ||
      e.target.closest('[aria-controls*="cart"]')
    ) {
      setTimeout(fgEnforce, 300);
    }
  });

  // Block checkout if only gift exists
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('button[name="checkout"], a[href*="checkout"]');
    if (!checkoutBtn) return;

    fgGetCart().then(function (cart) {
      var hasPaid = cart.items.some(function (i) { return !fgIsGiftItem(i); });
      var hasGift = cart.items.some(fgIsGiftItem);
      if (hasGift && !hasPaid) {
        e.preventDefault();
        alert('Free gifts require a qualifying purchase.');
        fgEnforce();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playr-advertorial-v3"] && !Shopify.designMode) return;
  try {
    
/**
 * PLAYR Advertorial cart bridge.
 *
 * Loaded as a THEME ASSET via theme.liquid ({{ 'playr-advertorial-bridge.js' | asset_url | script_tag }}).
 * Asset files are served with versioned URLs and are NOT subject to the Liquid
 * page/section/snippet render cache, so updates here go live immediately on push.
 * (Raw <script>/custom-element markup inside the page section gets stripped by
 * Shopify's content filter — an asset script does not, which is why this lives here.)
 *
 * Two features:
 *   (1) FREE-SHAKER AUTO-ADD — when a subscription item is in the cart and the
 *       free shaker is not, add one shaker so it shows as FREE in the drawer.
 *   (2) ADVERTORIAL CART-DRAWER WIRING — intercept the tier <form data-playr-form>
 *       submits, AJAX-add to cart via /cart/add.js (requesting the cart-drawer
 *       sections so the Horizon drawer can refresh), dispatch the theme's
 *       cart:update event, then open the slide-out drawer.
 *
 * Both are gated so the shaker logic runs everywhere but the form wiring only
 * activates when the advertorial root ([data-playr-root]) is present.
 */
(function () {
  'use strict';

  /* ===================================================================
   * (1) FREE-SHAKER AUTO-ADD
   * =================================================================== */
  var SHAKER_VARIANT_ID = 47304416526571;
  var SHAKER_HANDLE = 'free-shaker-with-first-order';
  var ATTEMPT_KEY = 'playr:shakerAutoAddAttempts';
  var MAX_ATTEMPTS_PER_SESSION = 3;
  var adding = false;

  function getAttempts() {
    try { return parseInt(sessionStorage.getItem(ATTEMPT_KEY) || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpAttempts() {
    try { sessionStorage.setItem(ATTEMPT_KEY, String(getAttempts() + 1)); }
    catch (e) {}
  }
  function resetAttempts() {
    try { sessionStorage.setItem(ATTEMPT_KEY, '0'); } catch (e) {}
  }

  // Returns a promise that resolves true if a shaker was added (so caller can refresh the drawer).
  function addShakerIfNeeded() {
    if (adding) return Promise.resolve(false);
    if (getAttempts() >= MAX_ATTEMPTS_PER_SESSION) return Promise.resolve(false);
    adding = true;
    return fetch('/cart.js')
      .then(function (r) { if (!r.ok) throw new Error('cart.js failed'); return r.json(); })
      .then(function (cart) {
        var hasSub = false, hasShaker = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].selling_plan_allocation) hasSub = true;
          if (cart.items[i].handle === SHAKER_HANDLE) hasShaker = true;
        }
        if (hasSub && !hasShaker) {
          bumpAttempts();
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: SHAKER_VARIANT_ID, quantity: 1 }] })
          }).then(function (r) { return r.ok; });
        }
        return false;
      })
      .catch(function () { return false; })
      .finally(function () { adding = false; });
  }

  /* ===================================================================
   * (2) ADVERTORIAL CART-DRAWER WIRING
   * =================================================================== */

  // --- runtime style: neutralize the display:none ancestor that hides the
  // nested <cart-drawer-component>, and force a fixed slide-out dialog. ---
  var STYLE_ID = 'playr-ppp-drawer-fix';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '#header-group{display:block !important;height:0 !important;min-height:0 !important;overflow:visible !important;visibility:visible !important;}'
      + '#header-group > .shopify-section:not(.cart-drawer-section),#header-group .header-section,#header-group .announcement-bar{display:none !important;}'
      + 'cart-drawer-component,.cart-drawer{display:block !important;visibility:visible !important;height:auto !important;overflow:visible !important;}'
      + 'cart-drawer-component > [data-testid="cart-drawer-trigger"],.cart-drawer > .header-actions__action{display:none !important;}'
      + 'dialog.cart-drawer__dialog,.cart-drawer__dialog{position:fixed !important;inset:0 0 0 auto !important;z-index:2147483000 !important;width:min(420px,92vw) !important;max-width:92vw !important;height:100dvh !important;max-height:100dvh !important;margin:0 !important;}'
      + 'dialog.cart-drawer__dialog:not([open]),.cart-drawer__dialog:not([open]){display:none !important;}'
      + 'dialog.cart-drawer__dialog[open],.cart-drawer__dialog[open]{display:flex !important;flex-direction:column !important;visibility:visible !important;}'
      + 'dialog.cart-drawer__dialog[open]::backdrop,.cart-drawer__dialog[open]::backdrop{background:rgba(15,23,42,0.5) !important;}';
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function getComp() { return document.querySelector('cart-drawer-component'); }
  function getDialog() {
    return document.querySelector('dialog.cart-drawer__dialog, .cart-drawer__dialog, cart-drawer-component dialog');
  }

  // Ask the theme's cart drawer to refresh its line items from the server, then
  // dispatch the cart:update event so cart-items-component morphs in the new HTML.
  function refreshDrawerSections() {
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });
    var url = '/?sections=' + encodeURIComponent(sectionIds.join(',')) + '&sections_url=' + encodeURIComponent(window.location.pathname);
    if (!sectionIds.length) {
      // Fallback: just fire a bare cart:update so listeners re-fetch.
      try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })); } catch (e) {}
      return Promise.resolve();
    }
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'playr-advertorial-bridge', data: { sections: sections } }
          }));
        } catch (e) {}
      })
      .catch(function () {
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })); } catch (e) {}
      });
  }

  function openDrawer() {
    injectStyle();
    var comp = getComp();
    if (comp && typeof comp.open === 'function') {
      try { comp.open(); var d0 = getDialog(); if (d0 && d0.open) return true; } catch (e) {}
    }
    var trig = document.querySelector('[data-testid="cart-drawer-trigger"], cart-drawer-component summary, [aria-controls*="cart-drawer"]');
    if (trig) {
      try { trig.click(); var d1 = getDialog(); if (d1 && d1.open) return true; } catch (e) {}
    }
    var dlg = getDialog();
    if (dlg) {
      try {
        if (dlg.open) { try { dlg.close(); } catch (e2) {} }
        if (typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
        dlg.setAttribute('open', '');
        if (typeof dlg.show === 'function') dlg.show();
        return true;
      } catch (e) {}
    }
    return false;
  }
  window.PLAYR_openCartDrawer = openDrawer;

  function setBtn(form, state, msg) {
    var btn = form.querySelector('[data-playr-cta]') || form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-cta-label]');
    if (!label) return;
    if (state === 'loading') {
      if (!label.hasAttribute('data-orig')) label.setAttribute('data-orig', label.textContent);
      label.textContent = 'Adding\u2026';
      if (btn) btn.classList.add('is-loading');
    } else if (state === 'added') {
      label.textContent = '\u2713 Added';
      if (btn) btn.classList.remove('is-loading');
    } else if (state === 'error') {
      label.textContent = msg || 'Sold out';
      if (btn) btn.classList.remove('is-loading');
    } else {
      if (label.hasAttribute('data-orig')) label.textContent = label.getAttribute('data-orig');
      if (btn) btn.classList.remove('is-loading');
    }
  }

  function rawAdd(variantId, sellingPlanId, quantity) {
    var item = { id: variantId, quantity: quantity || 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    });
  }

  function bindForms() {
    var forms = document.querySelectorAll('[data-playr-form]');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.dataset.pppBound === '1') return;
        form.dataset.pppBound = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (form.dataset.pppBusy === '1') return;
          form.dataset.pppBusy = '1';
          setBtn(form, 'loading');

          var idEl = form.querySelector('[name="id"]');
          var spEl = form.querySelector('[name="selling_plan"]');
          var qtyEl = form.querySelector('[name="quantity"]');
          var variantId = idEl ? idEl.value : null;
          var sellingPlanId = (spEl && spEl.value) ? spEl.value : null;
          var quantity = (qtyEl && parseInt(qtyEl.value, 10)) ? parseInt(qtyEl.value, 10) : 1;

          if (!variantId) {
            setBtn(form, 'error', 'Unavailable');
            form.dataset.pppBusy = '';
            setTimeout(function () { setBtn(form, 'reset'); }, 2400);
            return;
          }

          // Each new add session should be allowed to (re)add the shaker.
          resetAttempts();

          rawAdd(variantId, sellingPlanId, quantity).then(function (r) {
            if (r && r.ok === false) {
              var m = (r.data && (r.data.description || r.data.message)) || 'Sold out';
              setBtn(form, 'error', m);
              form.dataset.pppBusy = '';
              setTimeout(function () { setBtn(form, 'reset'); }, 2600);
              return;
            }
            setBtn(form, 'added');

            // For subscription items, auto-add the free shaker, THEN refresh + open.
            var post = sellingPlanId ? addShakerIfNeeded() : Promise.resolve(false);
            post.then(function () {
              return refreshDrawerSections();
            }).then(function () {
              var opened = openDrawer();
              if (!opened) { window.location.href = '/cart'; return; }
              form.dataset.pppBusy = '';
              setTimeout(function () { setBtn(form, 'reset'); }, 1600);
            });
          }).catch(function () {
            // Hard fallback: let the native form post so the user still reaches cart.
            form.dataset.pppBusy = '';
            try { form.submit(); } catch (e) { window.location.href = '/cart'; }
          });
        });
      })(forms[i]);
    }
  }

  /* ===================================================================
   * BOOT
   * =================================================================== */
  function boot() {
    // Shaker auto-add runs everywhere (handles direct cart visits too).
    addShakerIfNeeded();

    // Re-run shaker check whenever a <dialog> opens (cart drawer).
    try {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.target && m.target.tagName === 'DIALOG' && m.target.hasAttribute('open')) {
            setTimeout(addShakerIfNeeded, 400);
            break;
          }
        }
      });
      observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
    } catch (e) {}

    // Advertorial-only: wire the tier forms + drawer.
    if (document.querySelector('[data-playr-root]')) {
      injectStyle();
      bindForms();
      try {
        var mo = new MutationObserver(bindForms);
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ===== Free-gift enforcer (self-contained, merged from free-gift-enforcer.js) ===== */

  function fgGetCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function fgChangeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function fgIsGiftItem(item) {
    return item.properties && item.properties._free_gift === 'true';
  }

  function fgEnforce() {
    return fgGetCart().then(function (cart) {
      if (!cart || !cart.items) return;

      var giftLines = [];
      var hasNonGift = false;

      cart.items.forEach(function (item, idx) {
        var line = idx + 1;
        if (fgIsGiftItem(item)) {
          giftLines.push({ line: line, qty: item.quantity });
        } else {
          hasNonGift = true;
        }
      });

      // Remove gift if it's the only item
      if (!hasNonGift && giftLines.length) {
        return Promise.all(giftLines.map(function (g) { return fgChangeLine(g.line, 0); }));
      }

      // Force gift qty back to 1
      var overQty = giftLines.filter(function (g) { return g.qty > 1; });
      if (overQty.length) {
        return Promise.all(overQty.map(function (g) { return fgChangeLine(g.line, 1); }));
      }
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fgEnforce(); });
  } else {
    fgEnforce();
  }

  // Re-run when cart drawer opens / updates
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('[href*="/cart"]') ||
      e.target.closest('button[name="checkout"]') ||
      e.target.closest('.cart-drawer') ||
      e.target.closest('[aria-controls*="cart"]')
    ) {
      setTimeout(fgEnforce, 300);
    }
  });

  // Block checkout if only gift exists
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('button[name="checkout"], a[href*="checkout"]');
    if (!checkoutBtn) return;

    fgGetCart().then(function (cart) {
      var hasPaid = cart.items.some(function (i) { return !fgIsGiftItem(i); });
      var hasGift = cart.items.some(fgIsGiftItem);
      if (hasGift && !hasPaid) {
        e.preventDefault();
        alert('Free gifts require a qualifying purchase.');
        fgEnforce();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playr-lp-final-cta"] && !Shopify.designMode) return;
  try {
    
  class PlayrLpFinalForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.options = this.querySelectorAll('[data-option]');
      this.atcPrice = this.querySelector('[data-atc-price]');

      this.#bindOptionToggle();
      this.#bindFormSubmit();
    }

    #bindOptionToggle() {
      for (const option of this.options) {
        option.addEventListener('click', () => {
          for (const opt of this.options) {
            opt.classList.remove('playr-lp-cta__option--active');
          }
          option.classList.add('playr-lp-cta__option--active');
          const radio = option.querySelector('input[type="radio"]');
          radio.checked = true;

          const priceEl = option.querySelector('.playr-lp-cta__option-price');
          if (this.atcPrice && priceEl) {
            this.atcPrice.textContent = priceEl.textContent;
          }
        });
      }
    }

    #bindFormSubmit() {
      this.form?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const atcBtn = this.form.querySelector('.playr-lp-cta__atc');
        if (!atcBtn || atcBtn.disabled) return;

        atcBtn.disabled = true;
        const originalText = atcBtn.innerHTML;
        atcBtn.textContent = 'Adding...';

        try {
          const formData = new FormData(this.form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          });

          if (!response.ok) throw new Error('Add to cart failed');

          atcBtn.textContent = 'Added!';
          this.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: await response.json(),
            bubbles: true,
          }));

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            window.location.href = '/cart';
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          atcBtn.innerHTML = originalText;
        } finally {
          setTimeout(() => {
            atcBtn.disabled = false;
            atcBtn.innerHTML = originalText;
          }, 1500);
        }
      });
    }
  }

  customElements.define('playr-lp-final-form', PlayrLpFinalForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playr-product-hero"] && !Shopify.designMode) return;
  try {
    
  class PlayrProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.options = this.querySelectorAll('[data-option]');
      this.quantityInput = this.querySelector('.playr-hero__quantity-input');
      this.decreaseBtn = this.querySelector('[data-action="decrease"]');
      this.increaseBtn = this.querySelector('[data-action="increase"]');
      this.atcPrice = this.querySelector('[data-atc-price]');
      /* Gallery lives outside this web component — query from the parent section */
      const section = this.closest('.playr-hero');
      this.slides = section ? section.querySelectorAll('.playr-hero__slide') : [];
      this.thumbs = section ? section.querySelectorAll('.playr-hero__thumb') : [];

      this.#bindOptionToggle();
      this.#bindQuantity();
      this.#bindGallery();
      this.#bindFormSubmit();
    }

    #bindOptionToggle() {
      for (const option of this.options) {
        option.addEventListener('click', () => {
          for (const opt of this.options) {
            opt.classList.remove('playr-hero__option--active');
          }
          option.classList.add('playr-hero__option--active');
          const radio = option.querySelector('input[type="radio"]');
          radio.checked = true;

          /* Update ATC price display */
          const priceEl = option.querySelector('.playr-hero__option-price');
          if (this.atcPrice && priceEl) {
            this.atcPrice.textContent = priceEl.textContent;
          }
        });
      }
    }

    #bindQuantity() {
      if (!this.quantityInput) return;

      this.decreaseBtn?.addEventListener('click', () => {
        const current = parseInt(this.quantityInput.value, 10) || 1;
        if (current > 1) this.quantityInput.value = current - 1;
      });

      this.increaseBtn?.addEventListener('click', () => {
        const current = parseInt(this.quantityInput.value, 10) || 1;
        const max = parseInt(this.quantityInput.max, 10) || 10;
        if (current < max) this.quantityInput.value = current + 1;
      });
    }

    #bindGallery() {
      for (const thumb of this.thumbs) {
        thumb.addEventListener('click', () => {
          const index = parseInt(thumb.dataset.thumbIndex, 10);
          this.#goToSlide(index);
        });
      }

      /* Swipe support for mobile */
      const parentSection = this.closest('.playr-hero');
      const slidesContainer = parentSection ? parentSection.querySelector('.playr-hero__slides') : null;
      if (!slidesContainer) return;

      let startX = 0;
      let startY = 0;

      slidesContainer.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      slidesContainer.addEventListener('touchend', (e) => {
        const deltaX = e.changedTouches[0].clientX - startX;
        const deltaY = e.changedTouches[0].clientY - startY;

        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
          const activeSlide = parentSection.querySelector('.playr-hero__slide--active');
          const currentIndex = parseInt(activeSlide?.dataset.slideIndex, 10) || 0;
          const nextIndex = deltaX < 0
            ? Math.min(currentIndex + 1, this.slides.length - 1)
            : Math.max(currentIndex - 1, 0);
          this.#goToSlide(nextIndex);
        }
      }, { passive: true });
    }

    #goToSlide(index) {
      for (const slide of this.slides) {
        const isTarget = parseInt(slide.dataset.slideIndex, 10) === index;
        slide.classList.toggle('playr-hero__slide--active', isTarget);
        slide.setAttribute('aria-hidden', String(!isTarget));
      }
      for (const thumb of this.thumbs) {
        const isTarget = parseInt(thumb.dataset.thumbIndex, 10) === index;
        thumb.classList.toggle('playr-hero__thumb--active', isTarget);
        thumb.setAttribute('aria-selected', String(isTarget));
      }
    }

    #bindFormSubmit() {
      this.form?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const atcBtn = this.form.querySelector('.playr-hero__atc');
        if (!atcBtn || atcBtn.disabled) return;

        atcBtn.disabled = true;
        const originalText = atcBtn.innerHTML;
        atcBtn.textContent = 'Adding...';

        try {
          const formData = new FormData(this.form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          });

          if (!response.ok) throw new Error('Add to cart failed');

          atcBtn.textContent = 'Added!';
          this.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: await response.json(),
            bubbles: true,
          }));

          /* Open cart drawer or redirect */
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            window.location.href = '/cart';
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          atcBtn.innerHTML = originalText;
        } finally {
          setTimeout(() => {
            atcBtn.disabled = false;
            atcBtn.innerHTML = originalText;
          }, 1500);
        }
      });
    }
  }

  customElements.define('playr-product-form', PlayrProductForm);

  } catch(e) { console.error(e); }
})();
})();
